import i18n from "@/i18n";
import CenteredTitle from "@/components/centeredTitle/CenteredTitle.vue";
import TitleTextImage from "@/components/titleTextImage/TitleTextImage.vue";

export default {
    name: "AlternateCards",
    props: {
        "title": {type: String},
        "cards": {type: Array},
        "reversed": {type: Boolean},
        "greyFirst": {type: Boolean},
        "greyCenteredTitle": {type: Boolean}
    },
    data() {
        return {}
    },
    computed: {},
    created: function () {

    },
    components: {
        CenteredTitle,
        TitleTextImage
    },
    filters: {}

};
